<template>
<div>
<Subtitle v-bind:ServiceID="this.AppServiceID">
    <template v-slot:header>
    <i class="fas fa-fill-drip"></i><b>View Bulletins:</b>
    </template>
</Subtitle>
 <Card >
  <CardBody>
    <p>View all bulletins available for vaccine portal.
    </p>
</CardBody>
</Card> 
<v-client-table :columns="columns" :data="tableData" :options="options">
    <span class="pointer"  v-on:click="getPDF(props.row)" slot="bulletinname" slot-scope="props" ><u>{{props.row.bulletinname}}</u></span>
</v-client-table>   

</div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Vue from "vue";
import moment from "moment";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import TileNote from "@/Common/TileNote.vue";
import Modal from "@/Common/ModelPop.vue";
import Subtitle from "@/Common/Default/SubTitle.vue"; 
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
export default {
  props: { 
  },
  data: function () {
    return {  
    AppServiceID :'7',
    dateFormat :'',
      doc64String: "",
      bulletinname: "", 
      showPDF: false,
      size: "",
      id: "",
      showEditModal: false,
      showModal: false,
      succeeded: false,
      Msg: "",
      Button: "",
      PopUpVar: PopUpVariant,
      columns: [
        "bulletinname", 
        "effectivedate",       
        "expirydate", 
       
      ],
    //   columns: [
    //     "bulletinname",
    //     "name",
    //     "effectivedate",
    //     "postdate",
    //     "expirydate",
    //     "createuser",
    //     "createddatetime",
    //     "updateuser",
    //     "lastmodifieddatetime",
    //   ],
      tableData: [],
      options: {
        texts: {
          count:
            "Showing {from} to {to} of {count} records|{count} records|One record",
          first: "First",
          last: "Name",
          filter: "Search Bulletin:",
          filterPlaceholder: "Search Bulletin Name",
          limit: "Records:",
          page: "Page:",
          noResults: "No bulletin found",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },

        perPage: 10,
        perPageValues: [10, 15, 25],
        dateColumns: ["effectivedate", "expirydate", "createddatetime"],
        toMomentFormat: "YYYY-MM-DD",

        templates: {
          effectivedate(h, row) {
            return moment(row.effectivedate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          // postdate(h, row) {
          //   return moment(row.postdate, "YYYY-MM-DD").format("YYYY/MM/DD");
          // },
          expirydate(h, row) {
            return moment(row.expirydate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          createddatetime(h, row) {
            return moment(row.createddatetime, "YYYY-MM-DD").format(
              "YYYY/MM/DD"
            );
          },
          lastmodifieddatetime(h, row) {
            return moment(row.lastmodifieddatetime, "YYYY-MM-DD").format(
              "YYYY/MM/DD"
            );
          },
        },

        headings: {
          bulletinname: "Bulletin Name",
          //name: "Service Type",
          effectivedate: "Effective Date",
          //postdate: "Post Date",
          expirydate: "Expiry Date",
        //   createuser: "Created By",
        //   createddatetime: "Created Date",
        //   updateuser: "Last Modified By",
        //   lastmodifieddatetime: "Last Modified Date",
        },
        pagination: {
          edge: true,
          nav: "scroll",
          chunk: 5,
        },
        sortable: [
          "bulletinname",
          "name",
          "effectivedate",
          "postdate",
          "expirydate",
        ],
        filterable: [
          "bulletinname",
          "name",
          "effectivedate",
          "postdate",
          "expirydate",
        ],
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },
  components: {
    Modal: Modal,
    Card,
    CardBody,
    TileNote, 
    Subtitle,
  },
  created: function () { 
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetFHServiceID;
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.loadTable(); 
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetFHServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetFHServiceID);
  },
  mounted: function () {
 
  },
  computed: { 
  },
  methods: {
    closeModal() {
      this.showEditModal = false;
      this.loadTable();
    },
    ClosePopUp() {
      this.showModal = false;
    },
 
    loadTable() {
      var vm = this;
      var url = "SaskHealthApi/Security/GetViewPharmaBulletins?_=";

      var params = new URLSearchParams();
      params.append("id", 7);
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.tableData = response.data;
        })
        .catch(function (er) {
          ////console.log(er)
        });
    },
    getPDF:function(Rowdata){ 
        const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];        
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
        }  

            var vm = this;
            var url = 'SaskHealthApi/Security/GetPDF?_='
            var params = new URLSearchParams();
            params.append("id", Rowdata.id);
            // const params = { 
            //    id: Rowdata.id,
            //};
            axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
                const contentType = 'application/pdf';
                const blob = b64toBlob(response.data.pdf , contentType); 
                // const blobUrl = URL.createObjectURL(blob); 
                // const downloadLink = document.createElement("a");
                const fileName = Rowdata.pdfname; 
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var byteCharacters = atob(response.data.pdf);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i=0;i<byteCharacters.length;i++){
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var blobIE = new Blob([byteArray],{type: 'application.pdf'});
                    window.navigator.msSaveOrOpenBlob(blobIE,fileName);
                }
                else
                {
                    console.log("open _blank"); 
                    var win = open('', '_blank'); 
                    win.document.write(
                        '<html><body><center>' +
                        '<a title="Download PDF" style="font-family: \'Verdana\';color: #333;text-decoration: none;font-weight: 600;" download="' + Rowdata.pdfname + '" href="data:application/pdf;base64,' + response.data.pdf + '">Download File</a>' +
                        '</center><br>' +
                        '<object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + response.data.pdf  + '">' +
                        '<embed type="application/pdf" src="data:application/pdf;base64,' + response.data.pdf  + '" id="embed_pdf"></embed>' +
                        '</object></body></html>'); 
                 }
            })
            .catch(function (er) {
                 console.log(er)
            });
            
        }
  },
};
</script>

<style>
</style>
